import * as yup from 'yup';

export const custodian_details_schema = {
  isHaveCustodian: '',
  custodian_name: '',
  address_for_correspondence: '',
  account_name: '',
  account_number: '',
  certificate: '',
  dividends_other_income: '',
  sales_proceeds: '',
  have_existing_portfolio: '',
};

export const custodian_details_validation_schema = yup.object().shape({
  isHaveCustodian: yup.string(),

  custodianName: yup.string().when('isHaveCustodian', {
    is: '1',
    then: (schema) =>
      schema.required('custodian_name_required').max(100, 'max_100_characters'),
    otherwise: (schema) => schema.notRequired(),
  }),

  address: yup.string().when('isHaveCustodian', {
    is: '1',
    then: (schema) =>
      schema.required('address_required').max(100, 'max_100_characters'),
    otherwise: (schema) => schema.notRequired(),
  }),

  accountName: yup.string().when('isHaveCustodian', {
    is: '1',
    then: (schema) =>
      schema.required('account_name_required').max(100, 'max_100_characters'),
    otherwise: (schema) => schema.notRequired(),
  }),

  accountNumber: yup.string().when('isHaveCustodian', {
    is: '1',
    then: (schema) =>
      schema.required('account_number_required').max(20, 'max_20_characters'),
    otherwise: (schema) => schema.notRequired(),
  }),

  doYouHaveAnExistingPortfolio: yup.string(),

  toWhomShouldWeSendEachOfTheFollowingClient: yup
    .string()
    .required('certificate_indication_required'),
  toWhomShouldWeSendEachOfTheFollowingClientCustodian: yup.string(),
  toWhomShouldWeSendEachOfTheFollowingClientOther: yup
    .string()
    .when('toWhomShouldWeSendEachOfTheFollowingClient', {
      is: (val) => Number(val) === 803,
      then: (schema) =>
        schema
          .required('please_specify_other_certificate')
          .max(100, 'max_100_characters'),
      otherwise: (schema) => schema.notRequired(),
    }),

  toWhomShouldWeSendEachOfTheFollowingDividends: yup
    .string()
    .required('dividends_indication_required'),
  toWhomShouldWeSendEachOfTheFollowingDividendsCustodian: yup.string(),
  toWhomShouldWeSendEachOfTheFollowingDividendsOther: yup
    .string()
    .when('toWhomShouldWeSendEachOfTheFollowingDividends', {
      is: (val) => Number(val) === 803,
      then: (schema) =>
        schema
          .required('please_specify_other_devidends')
          .max(100, 'max_100_characters'),
      otherwise: (schema) => schema.notRequired(),
    }),

  toWhomShouldWeSendEachOfTheFollowingSalesProceeds: yup
    .string()
    .required('sales_proceed_indication_required'),
  toWhomShouldWeSendEachOfTheFollowingSalesProceedsCustodian: yup.string(),
  toWhomShouldWeSendEachOfTheFollowingSalesProceedsOther: yup
    .string()
    .when('toWhomShouldWeSendEachOfTheFollowingSalesProceeds', {
      is: (val) => Number(val) === 803,
      then: (schema) =>
        schema
          .required('please_specify_other_sales')
          .max(100, 'max_100_characters'),
      otherwise: (schema) => schema.notRequired(),
    }),

  // Ideal Investment Portfolio
  clientIdealInvestmentPortfolioDepositsAndMurabaha: yup.string(),
  clientIdealInvestmentPortfolioDebitInstruments: yup.string(),
  clientIdealInvestmentPortfolioStocks: yup.string(),
  clientIdealInvestmentPortfolioRealEstate: yup.string(),
  clientIdealInvestmentPortfolioDerivativesContracts: yup.string(),
  clientIdealInvestmentPortfolioAlternativeInvestments: yup.string(),
  clientIdealInvestmentPortfolioInvestmentFunds: yup.string(),

  // Current Investment Portfolio
  clientCurrentInvestmentPortfolioDepositsAndMurabaha: yup.string(),
  clientCurrentInvestmentPortfolioDebitInstruments: yup.string(),
  clientCurrentInvestmentPortfolioStocks: yup.string(),
  clientCurrentInvestmentPortfolioRealEstate: yup.string(),
  clientCurrentInvestmentPortfolioDerivativesContracts: yup.string(),
  clientCurrentInvestmentPortfolioAlternativeInvestments: yup.string(),
  clientCurrentInvestmentPortfolioInvestmentFunds: yup.string(),
});
